import { gql } from '@apollo/client';

export const GET_CARBON_TARGETS_QUERY = gql`
  query getCarbonTargetsQuery($group_id: String!, $company_id: String!, $id: String) {
    carbon_targets(group_id: $group_id, company_id: $company_id, id: $id) {
      id
      created
      modified
      deleted
      type
      breakdown
      baseline_year {
        id
        name
      }
      target_year {
        id
        name
      }
      target
    }
  }
`;
